/* global angular */
var ControlsController = require('./ControlsController');
var LatLngRenderer = require('./lib/LatLngRenderer');
var ScaleRenderer = require('./lib/ScaleRenderer');
var ElevationRenderer = require('./lib/ElevationRenderer');
var OpacitySliderRenderer = require('./lib/OpacitySliderRenderer');

function ControlsDirective ($compile, $templateCache, Utils) {

  function link ($scope, $el, $attrs, ctrls) {
    var ctrl = ctrls[0];
    var mapCtrl = ctrls[1];
    var Actions = mapCtrl.Actions;
    var Store = mapCtrl.Store;

    var scale, latlng, elevation, opacity;

    if ($attrs.hasOwnProperty('opacity')) {
      ctrl.showOpacity = true;
    }

    Store.getMap().then(function (map) {
      ctrl.init(map, Actions, Store);

      var elevationTemplate = $templateCache.get('saturn/map/controls/templates/elevation.tpl.html');

      var elevationContainer = angular.element($el[0].querySelector('.elevation'));
      var latlngContainer = angular.element($el[0].querySelector('.latlng'));
      var scaleContainer = angular.element($el[0].querySelector('.scale'));
      var opacityContainer = angular.element($el[0].querySelector('.opacity'));

      latlng = renderLatLng($scope, latlngContainer, map);
      scale = renderScale($scope, scaleContainer, map);
      elevation = renderElevation($scope, elevationContainer, elevationTemplate, map);
      opacity = renderOpacity($scope, opacityContainer, map);

      Utils.Ctrl.watch($attrs, $scope, ctrl, 'elevation', function (elv) {
        if (elevation !== undefined) {
          elevation.updateElevation(elv);
        }
      });

      Utils.Ctrl.watch($attrs, $scope, ctrl, 'metric', function (val, oldVal) {
        if (val !== oldVal) {
          scale.removeListeners(); // cleanup before replacing
          scale = renderScale($scope, scaleContainer, map, {
            metric: false
          });
        }
      });
    });

    $scope.$on('$destroy', function () {
      scale.removeListeners();
      latlng.removeListeners();
      opacity.removeListeners();
    });
  }

  function addElementToMap ($scope, renderer, container) {
    var el = renderer.getElement();
    var compileFn = $compile(el);

    container.empty();
    container.append(el);
    compileFn($scope);
  }

  function renderLatLng ($scope, container, map, options) {
    var latlng = new LatLngRenderer(map, options);
    addElementToMap($scope, latlng, container);
    return latlng;
  }

  function renderScale ($scope, container, map, options) {
    options = options || {};
    options.metric = $scope.vm.metric;
    var scale = new ScaleRenderer(map, options);
    addElementToMap($scope, scale, container);
    return scale;
  }

  function renderElevation ($scope, container, template, map, options) {
    var elevation = new ElevationRenderer(map, template, options);
    addElementToMap($scope, elevation, container);
    return elevation;
  }

  function renderOpacity ($scope, container, map, options) {
    var opacity = new OpacitySliderRenderer($scope, map, options);
    addElementToMap($scope, opacity, container);
    return opacity;
  }

  return {
    bindToController: true,
    controller: ControlsController,
    controllerAs: 'vm',
    link: link,
    require: ['sbMapControls', '^sbMap'],
    scope: {
      show: '=?',
      metric: '=?',
      elevation: '=?',
      opacity: '=?'
    },
    templateUrl: 'saturn/map/controls/controls.tpl.html'
  };
}

ControlsDirective.$inject = ['$compile', '$templateCache', 'sbMapUtils'];
module.exports = ControlsDirective;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/controls/ControlsDirective.js